import AzureDB from "../../../../contents/docs/cdp/sources/_snippets/source-azure-db.mdx";
import * as React from 'react';
export default {
  AzureDB,
  React
};